import React from 'react';
import logo_ktl from "../resources/images/partners/ktl.jpeg";
import logo_jelken from "../resources/images/partners/logo_jelken.jpg";
import logo_akimat_almaty from "../resources/images/partners/logo_almaty_akimat.jpg";
import logo_upr from "../resources/images/partners/logo_upr.jpeg";
import logo_ustaz from "../resources/images/partners/logo_ustaz.png";
import logo_enu from "../resources/images/partners/logo_enu.png";
import logo_khabar from "../resources/images/partners/logo_khabar.jpg";
import logo_buketov from "../resources/images/partners/logo_buketov.jpg";
import logo_ird from "../resources/images/partners/logo_ird.jpg"
import logo_upr_krg from "../resources/images/partners/logo_upr_krg.jpg"
import logo_upr_jet from "../resources/images/partners/logo_upr_jet.jpg"

const partnerLogos = [
  { src: logo_ktl, alt: "МОФ Білім-Инновация" },
  { src: logo_jelken, alt: "ОФ Jelken Foundation" },
  { src: logo_akimat_almaty, alt: "Акимат Алматинской области" },
  { src: logo_upr, alt: "Управление образования акимата Алматинской области" },
  { src: logo_khabar, alt: "Телеканал Хабар" },
  { src: logo_buketov, alt: "Карагандинский университет имени Е. А. Букетова" },
  { src: logo_enu, alt: "Евразийский национальный университет имени Л. Н. Гумилёва" },
  { src: logo_ustaz, alt: "Ustaz Pro" },
  { src: logo_ird, alt: "Институт раннего развития детей" },
  { src: logo_upr_krg, alt: "Управление образования Карагандинской области" },
  { src: logo_upr_jet, alt: "Управление образования области Жетісу" },
];

export const Partners = () => {
  return (
    <div id='partners' className="bg-white py-16 md:py-20 font-montserrat">
      <div className="mx-auto max-w-6xl px-6 lg:px-8">
        <h2 className="text-center text-3xl font-semibold pb-10 md:pb-12 leading-8 text-gray-900">
          Наши партнеры
        </h2>

        <div
          className="w-full inline-flex flex-nowrap overflow-hidden"
          style={{
            maskImage: 'linear-gradient(to right, transparent 0, black 10%, black 90%, transparent 100%)',
            WebkitMaskImage: 'linear-gradient(to right, transparent 0, black 10%, black 90%, transparent 100%)',
          }}
        >
          <ul className="flex items-center justify-center md:justify-start [&_li]:mx-6 [&_img]:max-w-none animate-infinite-scroll hover:[animation-play-state:paused]">
            {partnerLogos.map((partner, index) => (
              <li key={`partner-${index}`} className="flex-shrink-0">
                <div className="h-20 w-36 flex items-center justify-center">
                   <img
                     src={partner.src}
                     alt={partner.alt}
                     className="max-h-full max-w-full object-contain"
                   />
                </div>
              </li>
            ))}
             {partnerLogos.map((partner, index) => (
              <li key={`partner-dup-${index}`} className="flex-shrink-0" aria-hidden="true">
                <div className="h-20 w-36 flex items-center justify-center">
                   <img
                     src={partner.src}
                     alt=""
                     className="max-h-full max-w-full object-contain"
                   />
                </div>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default Partners;
